import React from "react";
import { differenceInYears } from "date-fns";

import { DateTime } from "../datetime";

export const DoB: React.FC<{ value: string }> = ({ value }) => {
  const age = differenceInYears(new Date(), new Date(value));
  return (
    <>
      <DateTime format={DateTime.FORMAT.DATE} value={value} /> ({age})
    </>
  );
};
